const lazyPaths = {
  "accessibility": () => import('./icons/accessibility.js'),
  "add-note": () => import('./icons/add-note.js'),
  "add-playlist": () => import('./icons/add-playlist.js'),
  "add-user": () => import('./icons/add-user.js'),
  "add": () => import('./icons/add.js'),
  "airplay": () => import('./icons/airplay.js'),
  "arrow-collapse-in": () => import('./icons/arrow-collapse-in.js'),
  "arrow-collapse": () => import('./icons/arrow-collapse.js'),
  "arrow-down": () => import('./icons/arrow-down.js'),
  "arrow-expand-out": () => import('./icons/arrow-expand-out.js'),
  "arrow-expand": () => import('./icons/arrow-expand.js'),
  "arrow-left": () => import('./icons/arrow-left.js'),
  "arrow-right": () => import('./icons/arrow-right.js'),
  "arrow-up": () => import('./icons/arrow-up.js'),
  "bookmark": () => import('./icons/bookmark.js'),
  "camera": () => import('./icons/camera.js'),
  "chapters": () => import('./icons/chapters.js'),
  "chat-collapse": () => import('./icons/chat-collapse.js'),
  "chat": () => import('./icons/chat.js'),
  "check": () => import('./icons/check.js'),
  "chevron-down": () => import('./icons/chevron-down.js'),
  "chevron-left": () => import('./icons/chevron-left.js'),
  "chevron-right": () => import('./icons/chevron-right.js'),
  "chevron-up": () => import('./icons/chevron-up.js'),
  "chromecast": () => import('./icons/chromecast.js'),
  "clip": () => import('./icons/clip.js'),
  "closed-captions-on": () => import('./icons/closed-captions-on.js'),
  "closed-captions": () => import('./icons/closed-captions.js'),
  "comment": () => import('./icons/comment.js'),
  "computer": () => import('./icons/computer.js'),
  "device": () => import('./icons/device.js'),
  "download": () => import('./icons/download.js'),
  "episodes": () => import('./icons/episodes.js'),
  "eye": () => import('./icons/eye.js'),
  "fast-backward": () => import('./icons/fast-backward.js'),
  "fast-forward": () => import('./icons/fast-forward.js'),
  "flag": () => import('./icons/flag.js'),
  "fullscreen-arrow-exit": () => import('./icons/fullscreen-arrow-exit.js'),
  "fullscreen-arrow": () => import('./icons/fullscreen-arrow.js'),
  "fullscreen-exit": () => import('./icons/fullscreen-exit.js'),
  "fullscreen": () => import('./icons/fullscreen.js'),
  "heart": () => import('./icons/heart.js'),
  "info": () => import('./icons/info.js'),
  "language": () => import('./icons/language.js'),
  "link": () => import('./icons/link.js'),
  "lock-closed": () => import('./icons/lock-closed.js'),
  "lock-open": () => import('./icons/lock-open.js'),
  "menu-horizontal": () => import('./icons/menu-horizontal.js'),
  "menu-vertical": () => import('./icons/menu-vertical.js'),
  "microphone": () => import('./icons/microphone.js'),
  "mobile": () => import('./icons/mobile.js'),
  "moon": () => import('./icons/moon.js'),
  "music-off": () => import('./icons/music-off.js'),
  "music": () => import('./icons/music.js'),
  "mute": () => import('./icons/mute.js'),
  "next": () => import('./icons/next.js'),
  "no-eye": () => import('./icons/no-eye.js'),
  "notification": () => import('./icons/notification.js'),
  "odometer": () => import('./icons/odometer.js'),
  "pause": () => import('./icons/pause.js'),
  "picture-in-picture-exit": () => import('./icons/picture-in-picture-exit.js'),
  "picture-in-picture": () => import('./icons/picture-in-picture.js'),
  "play": () => import('./icons/play.js'),
  "playback-speed-circle": () => import('./icons/playback-speed-circle.js'),
  "playlist": () => import('./icons/playlist.js'),
  "previous": () => import('./icons/previous.js'),
  "question-mark": () => import('./icons/question-mark.js'),
  "queue-list": () => import('./icons/queue-list.js'),
  "radio-button-selected": () => import('./icons/radio-button-selected.js'),
  "radio-button": () => import('./icons/radio-button.js'),
  "repeat-on": () => import('./icons/repeat-on.js'),
  "repeat-square-on": () => import('./icons/repeat-square-on.js'),
  "repeat-square": () => import('./icons/repeat-square.js'),
  "repeat": () => import('./icons/repeat.js'),
  "replay": () => import('./icons/replay.js'),
  "rotate": () => import('./icons/rotate.js'),
  "search": () => import('./icons/search.js'),
  "seek-backward-10": () => import('./icons/seek-backward-10.js'),
  "seek-backward-15": () => import('./icons/seek-backward-15.js'),
  "seek-backward-30": () => import('./icons/seek-backward-30.js'),
  "seek-backward": () => import('./icons/seek-backward.js'),
  "seek-forward-10": () => import('./icons/seek-forward-10.js'),
  "seek-forward-15": () => import('./icons/seek-forward-15.js'),
  "seek-forward-30": () => import('./icons/seek-forward-30.js'),
  "seek-forward": () => import('./icons/seek-forward.js'),
  "send": () => import('./icons/send.js'),
  "settings-menu": () => import('./icons/settings-menu.js'),
  "settings-switch": () => import('./icons/settings-switch.js'),
  "settings": () => import('./icons/settings.js'),
  "share-arrow": () => import('./icons/share-arrow.js'),
  "share": () => import('./icons/share.js'),
  "shuffle-on": () => import('./icons/shuffle-on.js'),
  "shuffle": () => import('./icons/shuffle.js'),
  "stop": () => import('./icons/stop.js'),
  "subtitles": () => import('./icons/subtitles.js'),
  "sun": () => import('./icons/sun.js'),
  "theatre-mode-exit": () => import('./icons/theatre-mode-exit.js'),
  "theatre-mode": () => import('./icons/theatre-mode.js'),
  "thumbs-down": () => import('./icons/thumbs-down.js'),
  "thumbs-up": () => import('./icons/thumbs-up.js'),
  "timer": () => import('./icons/timer.js'),
  "transcript": () => import('./icons/transcript.js'),
  "tv": () => import('./icons/tv.js'),
  "user": () => import('./icons/user.js'),
  "volume-high": () => import('./icons/volume-high.js'),
  "volume-low": () => import('./icons/volume-low.js'),
  "x-mark": () => import('./icons/x-mark.js')
};

export { lazyPaths };
